var map = {
	"./app-store-ios.svg": "7603",
	"./central-klaus.svg": "70bb",
	"./componente-nfse.png": "c1e6",
	"./custom.scss": "de82",
	"./google-play.svg": "1457",
	"./klaus-a1.svg": "fa93",
	"./klaus-a3.svg": "e759",
	"./kpdf.png": "9380",
	"./logo-klaus-rebrand.svg": "b554",
	"./logo_suite_klaus.svg": "be03",
	"./robo-klaus.svg": "f8b3",
	"./robo-lite.png": "ced0",
	"./screenshots/central-klaus-1.png": "c2e1",
	"./screenshots/central-klaus-2.png": "6999",
	"./screenshots/central-klaus-3.jpg": "0fe8",
	"./screenshots/central-klaus-4.png": "8022",
	"./screenshots/klaus-a1-1.png": "02cb",
	"./screenshots/klaus-a1-2.png": "b2fd",
	"./screenshots/klaus-a1-3.jpg": "ace4",
	"./screenshots/klaus-a3-1.jpg": "5940",
	"./screenshots/klaus-a3-2.jpg": "b28d",
	"./screenshots/klaus-a3-3.jpg": "426f",
	"./screenshots/kpdf-1.png": "dc8f",
	"./screenshots/kpdf-2.jpg": "7f5b",
	"./screenshots/kpdf-3.jpg": "1dbc",
	"./screenshots/robo-klaus-1.png": "889f",
	"./screenshots/robo-klaus-2.png": "b08b",
	"./theme.css": "d8ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";